export default __webpack_public_path__ + "static/media/Water sports.7cdade71.svg";